import { supabase } from '@/lib/supabase/client';

export interface StorePaymentCredential {
  id?: string;
  store_id: string;
  platform: string;
  credentials_encrypted: string;
  created_at?: string;
  updated_at?: string;
}

// Guardar credenciales SIN encriptar (la encriptación se hace en Supabase o Edge Function)
export async function saveStorePaymentCredentialRaw(storeId: string, platform: string, credentials: Record<string, any>) {
  try {
    
    const { data, error } = await supabase
      .from('store_payment_credentials')
      .upsert({
        store_id: storeId,
        platform,
        credentials_encrypted: JSON.stringify(credentials), // Guardamos como JSON sin encriptar por ahora
        updated_at: new Date().toISOString(),
      }, { onConflict: 'store_id,platform' })
      .select()
      .single();
    
    if (error) {
      console.error(`[saveStorePaymentCredentialRaw] Error en upsert:`, error);
      throw error;
    }
    
    return data as StorePaymentCredential;
  } catch (err: any) {
    console.error(`[saveStorePaymentCredentialRaw] Error completo:`, err);
    throw new Error(`No se pudo guardar las credenciales de pago: ${err?.message || 'Error desconocido'}`);
  }
}

// Verificar si existen credenciales encriptadas para una plataforma
// NOTA: Las credenciales encriptadas NO pueden desencriptarse en el cliente.
// Este función solo verifica su existencia. El desencriptado se hace en los Edge Functions.
export async function getStorePaymentCredential(storeId: string, platform: string): Promise<boolean> {
  const { data, error } = await supabase
    .from('store_payment_credentials')
    .select('id')
    .eq('store_id', storeId)
    .eq('platform', platform)
    .maybeSingle();
  
  
  if (error || !data) {
    return false;
  }
  
  return true;
}
